import * as React from 'react';

/**
 * Context used for tracking the closest scrollable parent
 */
const ScrollParentContext = React.createContext(typeof window !== 'undefined' ? window.document.body : null);
/**
 * Hook for obtaining a reference to the closest scrollable parent
 */
function useScrollParent() {
    return React.useContext(ScrollParentContext);
}
/**
 * Provider for useScrollParent hook
 */
const ScrollParentProvider = ScrollParentContext.Provider;

export { ScrollParentContext, ScrollParentProvider, useScrollParent };
